import { store } from '@/state/store';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';

export function FN_FIELD_IMAGE__edit__update_field(graph: DTO_GRAPH__instance) {
  let { g_image_edit__field } = store.getState().slice_ui;

  if (g_image_edit__field.is_stub()) return;
  if (g_image_edit__field.meta.graph_id != graph.meta.graph_id) return;

  let fields_map = graph.fields__get_map();

  let field_updated = FIELD__image_asset.CREATE_STUB();

  if (fields_map.has(g_image_edit__field.meta.field_id)) {
    let field_from_graph = fields_map.get_or_assert(g_image_edit__field.meta.field_id);
    assert_instanceof(field_from_graph, FIELD__image_asset);

    field_updated = field_from_graph;
  }

  store.dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field: field_updated }));
}
